import * as React from 'react';

import { LayoutChangeEvent } from 'react-native';

import { useSystemwidePromotionMessageQuery } from 'generated/sanity-graphql';
import { useIsLoyaltyEnabled } from 'state/loyalty/hooks/use-is-loyalty-enabled';
import { useLoyaltyUser } from 'state/loyalty/hooks/use-loyalty-user';
import { useUIContext } from 'state/ui';

import { RibbonContent, RibbonWrapper, StyledRibbon } from './styled';

let alreadyLoadedOnce = false;

export const PromoMessageRibbon = () => {
  const loyaltyEnabled = useIsLoyaltyEnabled();
  const { loyaltyUser, loading: loyaltyLoading } = useLoyaltyUser();
  const { promoMessageHeightRef } = useUIContext();
  const promoId = loyaltyUser?.bestPromotion?.sanityId ?? '';

  // alreadyLoadedOnce is a hack to prevent skipping the query which makes it null and flashing occurs
  const skip = !alreadyLoadedOnce && (!loyaltyEnabled || loyaltyLoading || !promoId);

  const { data } = useSystemwidePromotionMessageQuery({
    variables: {
      id: promoId,
    },
    skip,
    fetchPolicy: 'cache-and-network',
  });

  const promoMessage = data?.SystemwidePromotion?.promoMessage?.locale;

  if (data) {
    alreadyLoadedOnce = true;
  }

  if (!promoMessage) {
    promoMessageHeightRef.current = 0;
    return null;
  }

  const handleLayout = (event: LayoutChangeEvent) => {
    promoMessageHeightRef.current = event.nativeEvent.layout.height;
  };

  return (
    <RibbonContent onLayout={handleLayout}>
      <RibbonWrapper>
        <StyledRibbon>{promoMessage}</StyledRibbon>
      </RibbonWrapper>
    </RibbonContent>
  );
};
